import { defineComponent as b, useCssVars as f, ref as g, computed as i, watch as m } from "vue";
import v from "./td-longtail-vue-components15.js";
import h from "./td-longtail-vue-components3.js";
const B = /* @__PURE__ */ b({
  __name: "carousel-navigation",
  props: {
    pages: { default: void 0 },
    ariaLabel: { default: "Pagination %d Seiten" },
    infinity: { type: Boolean },
    labelPrev: { default: "Vorherige Seite" },
    labelNext: { default: "Nächste Seite" },
    hidePages: { type: Boolean },
    hidePagesMobile: { type: Boolean },
    primary: { type: Boolean },
    secondary: { type: Boolean },
    buttonLabelFirst: { default: "Gehe zur ersten Seite" },
    buttonLabelLast: { default: "Gehe zur letzten Seite" },
    buttonLabel: { default: "Gehe zu Seite %d" },
    doNotScrollIntoView: { type: Boolean }
  },
  emits: ["update"],
  setup(l, { emit: n }) {
    const e = l;
    f((o, a) => ({
      "18157bc5": a.justifyContainer,
      "43eefe54": a.paginationDisplay
    }));
    const r = g(null), u = (o, a) => a.number === 0 ? e.buttonLabelFirst : a.number === o.length - 1 ? e.buttonLabelLast : e.buttonLabel.replace("%d", (a.number + 1).toString()), t = i(() => e.pages?.find((o) => o.active)), s = i(() => e.hidePagesMobile ? "none" : "inline-flex"), c = i(() => e.hidePagesMobile ? "flex-end" : "center"), p = () => {
      t.value && (t.value.number - 1 < 0 ? n("update", e.pages?.length ? e.pages.length - 1 : 0) : n("update", t.value.number - 1));
    }, d = () => {
      t.value && (t.value.number + 1 > (e.pages?.length || 0) - 1 ? n("update", 0) : n("update", t.value.number + 1));
    };
    return m(
      () => e.pages,
      () => {
        e.doNotScrollIntoView || setTimeout(() => {
          r.value && r.value.querySelector(".carousel-navigation__link--active")?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        }, 10);
      },
      { deep: !0 }
    ), { __sfc: !0, props: e, carouselNavigationElement: r, emits: n, ariaLabelForPageNumber: u, activePage: t, paginationDisplay: s, justifyContainer: c, clickPrev: p, clickNext: d, ForwardBackwardButton: v, LinkButton: h };
  }
});
export {
  B as default
};
